'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);

var _ = require('../');

var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _parkingConverter = require('../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);
var _checkers = require('../../utils/checkers');
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _getMapUrl = require('../../utils/getMapUrl');var _getMapUrl2 = _interopRequireDefault(_getMapUrl);

var _constants = require('../../constants');
var _PropertyDetailsPrintPage = require('./PropertyDetailsPrintPage.scss');var _PropertyDetailsPrintPage2 = _interopRequireDefault(_PropertyDetailsPrintPage);
var _pin = require('../../../static/icons/pin.svg');var _pin2 = _interopRequireDefault(_pin);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}


var Address = function Address(_ref) {var cityName = _ref.city_name,neighborhood = _ref.neighborhood,streetName = _ref.street_name,houseNumber = _ref.house_number;
  var formattedNeighborhood = cityName === neighborhood ? '' : neighborhood + ',';

  return (
    _react2.default.createElement('span', null, streetName, ' ', houseNumber, ', ', cityName, ' ', formattedNeighborhood));

};

Address.propTypes = {
  city_name: _propTypes2.default.string,
  neighborhood: _propTypes2.default.string,
  street_name: _propTypes2.default.string,
  house_number: _propTypes2.default.string };


function renderColumn(array, idx) {
  return (
    _react2.default.createElement('div', { key: idx },
      array.map(function (_ref2) {var title = _ref2.title,value = _ref2.value;return (
          _react2.default.createElement('div', { key: title.toString() },
            _react2.default.createElement('span', { className: _PropertyDetailsPrintPage2.default.singleDetail }, title), ' ' +
            value));})));




}

function renderDetails(detailsData) {
  var data = detailsData.map(function (detail) {
    if (_constants.alwaysDisplayedPropertyData.includes(detail.type)) {
      detail.value = detail.value || '–';
    }

    return detail;
  });

  var notEmptyData = data.filter(function (_ref3) {var value = _ref3.value;return !!value;});
  var columnQuantity = Math.ceil(notEmptyData.length / 2);
  var firstColumn = notEmptyData.slice(0, columnQuantity);
  var secondColumn = notEmptyData.slice(columnQuantity);

  return [firstColumn, secondColumn].map(renderColumn);
}

var Contacts = function Contacts(_ref4) {var translate = _ref4.translate,contacts = _ref4.contacts,realtorProperty = _ref4.realtorProperty;return (
    _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.contacts },
      ['primary', 'secondary'].map(function (contactType, idx) {
        var contact = contacts[contactType];

        if (!contact || !contact.phone) {
          return null;
        }

        return (
          _react2.default.createElement('div', { key: contactType },
            !!idx && _react2.default.createElement('hr', null),

            !idx &&
            _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.title },
              _react2.default.createElement('span', { className: _PropertyDetailsPrintPage2.default.colorBlue }, translate('contacts', 'title'))),


            !idx && realtorProperty &&
            _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.realtor },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.iconContainer },
                _react2.default.createElement('i', { className: 'icon icon-office' })),


              _react2.default.createElement('span', null, contact.company_name)),



            _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.name },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.iconContainer },
                _react2.default.createElement('i', { className: 'icon icon-user' })),


              _react2.default.createElement('span', null, contact.name)),


            _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.contactData },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.iconContainer },
                _react2.default.createElement('i', { className: 'icon icon-phone' })),


              _react2.default.createElement('span', null, (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(contact.phone)))),


            !(0, _checkers.isTemporaryEmail)(contact.email) &&
            _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.contactData },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.iconContainer },
                _react2.default.createElement('i', { className: 'icon icon-mail' })),


              _react2.default.createElement('span', null, contact.email))));




      })));};



Contacts.propTypes = {
  translate: _propTypes2.default.func,
  contacts: _propTypes2.default.object,
  realtorProperty: _propTypes2.default.bool };var


PropertyDetailsPrintPage = function (_Component) {_inherits(PropertyDetailsPrintPage, _Component);function PropertyDetailsPrintPage() {var _temp, _this, _ret;_classCallCheck(this, PropertyDetailsPrintPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.


























    closePrintPage = function () {
      _this.props.hidePrintPage();
    }, _this.

    printWatcher = function (mql) {return mql && !mql.matches && _this.closePrintPage();}, _this.

    render = function () {var _cx;var _this$props =
      _this.props,data = _this$props.data,isRtl = _this$props.isRtl,locale = _this$props.locale,translate = _this$props.translate,propertyType = _this$props.propertyType;var

      price =
























      data.price,searchOption = data.searchOption,isCottage = data.isCottage,localisedAddress = data.localisedAddress,neighborhood = data.neighborhood,isGroundFloor = data.isGroundFloor,floorOn = data.floorOn,entryDate = data.entryDate,shouldRenderDate = data.shouldRenderDate,translatedDirections = data.translatedDirections,aboutProperty = data.aboutProperty,parking = data.parking,rooms = data.rooms,areaValue = data.areaValue,entryDateObject = data.entryDateObject,aboutBuilding = data.aboutBuilding,images = data.images,contacts = data.contacts,description = data.description,aboutPropertyAdditions = data.aboutPropertyAdditionals,aboutBuildingAdditions = data.aboutBuildingAdditionals,realtorProperty = data.realtorProperty,shouldRemovePropertyRealtorIcon = data.shouldRemovePropertyRealtorIcon,payments = data.payments,address = data.address;
      var hasPropertyImage = !!(images && images.length);
      var displayBuildingInfo = isCottage ?
      aboutBuilding.some(function (detail) {return !!detail.value && detail.value !== 0;}) :
      true;

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.propertyDetailsPrintPage, { rtl: isRtl }) },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.row, _PropertyDetailsPrintPage2.default.fillSpace, _PropertyDetailsPrintPage2.default.header) },
            _react2.default.createElement(Address, localisedAddress),
            _react2.default.createElement('img', {
              width: '88px',
              src: _constants.onMapLogoBlue,
              alt: '',
              title: '' + _this.props.translate('header', 'onMapHomepage') })),



          _react2.default.createElement('hr', null),

          _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.row, _PropertyDetailsPrintPage2.default.padded, _PropertyDetailsPrintPage2.default.fillSpace) },
            hasPropertyImage &&
            _react2.default.createElement('img', { src: images[0].full, alt: '' }),

            _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.mapContainer, (_cx = {}, _cx[_PropertyDetailsPrintPage2.default.onlyMap] = !hasPropertyImage, _cx)) },
              _react2.default.createElement('img', { src: (0, _getMapUrl2.default)(address.location, locale, hasPropertyImage), alt: 'map', className: _PropertyDetailsPrintPage2.default.mapImage }),
              _react2.default.createElement('img', { src: _pin2.default, alt: 'pin', className: _PropertyDetailsPrintPage2.default.mapPin }))),



          _react2.default.createElement('hr', null),

          _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.row, _PropertyDetailsPrintPage2.default.padded, _PropertyDetailsPrintPage2.default.fillSpace) },
            _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.summaryWrapper },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.rowTitle },
                _react2.default.createElement('span', null, propertyType),

                _react2.default.createElement('br', null),

                _react2.default.createElement('span', null, translate('propertyDetails', searchOption === 'buy' ? 'forSale' : 'forRent')),

                _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.realtorAdvertLabel },
                  !realtorProperty ?
                  _react2.default.createElement('div', null, _this.props.translate('propertyDetails', 'regularAdvert')) :
                  null,


                  realtorProperty && !shouldRemovePropertyRealtorIcon ?
                  _react2.default.createElement('div', null, _this.props.translate('propertyDetails', 'realtorAdvert')) :
                  null)),




              _react2.default.createElement(_.PropertySummary, {
                translate: translate('propertyDetails'),
                data: {
                  isCottage: isCottage,
                  price: (0, _beautifyNumber2.default)(price),
                  address: {
                    cityName: localisedAddress.city_name,
                    neighborhood: neighborhood,
                    streetName: localisedAddress.street_name,
                    houseNumber: localisedAddress.house_number },

                  additionalInfo: {
                    floor: isGroundFloor ? translate('propertyDetails', 'details', 'groundFloorShortcut') : floorOn,
                    parkingSpots: (0, _parkingConverter2.default)(parking),
                    area: areaValue,
                    rooms: rooms } },


                isRtl: isRtl })),



            _react2.default.createElement(Contacts, { translate: translate('propertyDetails'), contacts: contacts, realtorProperty: realtorProperty })),



          !!shouldRenderDate &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('hr', null),

            _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.row, _PropertyDetailsPrintPage2.default.padded) },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.rowTitle },
                translate('propertyDetails', 'entryDate')),


              _react2.default.createElement('div', null,
                entryDate && (0, _moment2.default)(entryDate).format('DD/MM/YYYY'),
                entryDateObject.immediate && ' ' + translate('propertyDetails', 'immediate'),
                entryDateObject.flexible && ' ' + translate('propertyDetails', 'flexible')))),






          !!description &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('hr', null),

            _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.row, _PropertyDetailsPrintPage2.default.padded) },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.rowTitle },
                translate('propertyDetails', 'description')),


              _react2.default.createElement('pre', null, description))),





          _react2.default.createElement('hr', null),

          _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.row, _PropertyDetailsPrintPage2.default.padded) },
            _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.rowTitle },
              translate('propertyDetails', 'details', 'aboutProperty')),


            _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.aboutProperty },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.columns },
                renderDetails(aboutProperty)),


              !!(translatedDirections && translatedDirections.length) &&
              _react2.default.createElement('div', null,
                _react2.default.createElement('span', { className: _PropertyDetailsPrintPage2.default.bolder }, translate('propertyDetails', 'details', 'directionOfTheWind'), ':'), '\xA0',

                translatedDirections.join(', ')),



              !!(aboutPropertyAdditions && aboutPropertyAdditions.length) &&
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.commodities },
                _react2.default.createElement('span', { className: _PropertyDetailsPrintPage2.default.singleDetail }, translate('propertyDetails', 'commodities', 'title') + ':'),
                aboutPropertyAdditions.map(function (commodity) {return (
                    _react2.default.createElement('span', { key: commodity }, translate('propertyDetails', 'commodities', commodity)));})))),







          (displayBuildingInfo || !!aboutBuildingAdditions.length) &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('hr', null),

            _react2.default.createElement('div', { className: (0, _classnames2.default)(_PropertyDetailsPrintPage2.default.row, _PropertyDetailsPrintPage2.default.padded) },
              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.rowTitle },
                translate('propertyDetails', 'details', 'aboutBuilding')),


              _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.aboutProperty },
                _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.columns },
                  renderDetails(aboutBuilding)),


                !!(aboutBuildingAdditions && aboutBuildingAdditions.length) &&
                _react2.default.createElement('div', { className: _PropertyDetailsPrintPage2.default.commodities },
                  _react2.default.createElement('span', { className: _PropertyDetailsPrintPage2.default.singleDetail }, translate('propertyDetails', 'commodities', 'title') + ':'),
                  aboutBuildingAdditions.map(function (commodity) {return (
                      _react2.default.createElement('span', null, translate('propertyDetails', 'commodities', commodity)));}))))),









          payments &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('hr', null),

            _react2.default.createElement(_.PropertyPaymentsBlock, {
              payments: payments,
              translate: translate('propertyDetails'),
              isCottageForSale: searchOption === 'buy' && _this.props.enPropertyType === 'cottage',
              isRtl: _this.props.isRtl,
              className: _PropertyDetailsPrintPage2.default.payments }))));





    }, _temp), _possibleConstructorReturn(_this, _ret);}PropertyDetailsPrintPage.prototype.componentWillMount = function componentWillMount() {if (global && global.window) {if (global.window.matchMedia) {this.mediaQueryList = window.matchMedia('print');this.mediaQueryList.addListener(this.printWatcher);}global.window.onafterprint = this.printWatcher;}};PropertyDetailsPrintPage.prototype.componentDidMount = function componentDidMount() {if (global && global.window) {setTimeout(window.print, 500);}};PropertyDetailsPrintPage.prototype.componentWillUnmount = function componentWillUnmount() {if (global.window) {if (this.mediaQueryList) {this.mediaQueryList.removeListener(this.printWatcher);}global.window.onafterprint = null;}};return PropertyDetailsPrintPage;}(_react.Component);


PropertyDetailsPrintPage.propTypes = {
  data: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  propertyType: _propTypes2.default.string,
  hidePrintPage: _propTypes2.default.func,
  enPropertyType: _propTypes2.default.string };exports.default =


PropertyDetailsPrintPage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailsPrintPage/PropertyDetailsPrintPage.js
// module id = 2830
// module chunks = 0